import { render, staticRenderFns } from "./ChangeRequestActions.vue?vue&type=template&id=f707ec5c&scoped=true"
import script from "./ChangeRequestActions.vue?vue&type=script&lang=ts"
export * from "./ChangeRequestActions.vue?vue&type=script&lang=ts"
import style0 from "./ChangeRequestActions.vue?vue&type=style&index=0&id=f707ec5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f707ec5c",
  null
  
)

export default component.exports